import TomSelect from "tom-select";


export default class GavList {
    constructor(form) {
        this.language = document.querySelector('html').lang;

        this.form = form;
        this.innerForm = this.form.querySelector('section.inner');
        this.formContainer = this.form.closest("section.gav-search");
        this.submitButton = this.formContainer.querySelector('input[type="submit"]');
        this.formAction = undefined;
        this.apiKey = undefined;
        this.apiUrl = undefined;
        this.printedJahrAlter = false;
        this.yearSelector = undefined;

        // save json structure from API
        this.formstructure = undefined;

        // user selection
        this.jobtitle = jobtitle;
        this.zipcode = zipcode;
        this.temporary = temporary;
        this.contractNumber = contractNumber;
        this.versionNumber = versionNumber;
        this.editionId = editionId;
        this.contractName = contractName;
        this.fileName = fileName;
        this.fileId = fileId;

        this.selectedValues = [];
        this.formstructure = new Array();
        this.formItemCount = 0;

        if (this.formContainer) {
            this.initializeForm();
        }
    }

    async initializeForm() {
        this.formAction = this.form.action;
        this.apiUrl = this.formContainer.dataset.apiurl;
        this.apiKey = this.formContainer.dataset.apikey;

        //check if edit parameter is set
        const params = new URLSearchParams(window.location.search);
        const editFlag = params.get("edit");
        if(editFlag) {
            // user wants to edit the form

            //restore data from local storage
            let userData = JSON.parse(localStorage.getItem("userData"));
            this.jobtitle = userData.jobtitle;
            this.zipcode = userData.zipcode;
            this.temporary = userData.temporary;
            this.contractNumber = userData.contractNumber;
            this.versionNumber = userData.versionNumber;
            this.editionId = userData.editionId;
            this.contractName = userData.contractName;
            this.fileName = userData.fileName;
            this.fileId = userData.fileId;

            //set contract title
            document.querySelector('.contract-name').innerHTML = this.contractName;

            this.selectedValues = JSON.parse(localStorage.getItem("selectedValues"));

            this.formstructure = JSON.parse(localStorage.getItem("structure"));

            this.printStructure(this.formstructure);
            await this.prefillFormstructure();

        } else {

            let printStructureReturn = this.printStructure(await this.getFormStructure());

            // loop through the return of printStructure() and can contain between zero and 2 items (year, age)
            for(let i = 0; i < printStructureReturn.length; i++) {
                let optionsForCurrentSelect = await this.getOptionsForCurrentSelect(printStructureReturn[i]);
            }
        }

        this.addSubmitListener();
    }

    async getFormStructure() {
        try {
            let endpoint = `/api/minimumsalary/${this.editionId}/structure?language=${this.language}-CH`;
            let url = this.apiUrl + endpoint;
            let requestHeaders = new Headers({
                "Unia-Api-Key": this.apiKey,
                'Content-Type': 'application/json'
            });
            const response = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                headers: requestHeaders
            }).catch(err => {
                console.error('fetch fail', err);
                throw new Error('Network response was not ok');
            });

            let structureResponse = await response.json();
            console.log('structureResponse', structureResponse);
            this.formstructure = structureResponse;

            if (structureResponse.length == 0) {
                throw new Error('structureResponse empty');
            }

            return structureResponse;
        } catch (error) {
            console.error('fetch fail', error);
            this.addFormdata();
            this.form.submit();
        }
    }

    async prefillFormstructure() {
        let selectedValues = this.selectedValues;
        let that = this;
        let i = 0;
        while(i < selectedValues.length) {
            let select = document.querySelector(`select[data-id="${selectedValues[i].CriteriaStructureId}"]`);
            if(select) {
                select.removeAttribute('disabled');
                let currentFormItem = select.closest('fieldset');
                currentFormItem.style.display = 'block';
                currentFormItem.classList.add('used');
                let value = selectedValues[i].Value;
                let options = await this.getOptions(selectedValues[i].CriteriaStructureId);
                that.initTomSelect(select, options, value);
                this.addEventListenersToCurrentFormItem(currentFormItem);
                this.submitButton.classList.remove('disabled');
            }
            i++;
        }
    }

    generateFormGroup(field) {
        const formGroup = document.createElement("fieldset");
        formGroup.id = `fieldset-${field.id}`;

        formGroup.style.display = 'none';

        //create and append label
        let label = document.createElement("label");
        label.htmlFor = `field-${field.id}`;
        label.innerText = field.title;
        formGroup.appendChild(label);

        //Create and append select list
        let selectList = document.createElement("select");
        selectList.id = `field-${field.id}`;
        selectList.dataset.id = field.id;
        selectList.dataset.parentid = field.parentId;
        selectList.setAttribute('autocomplete', 'off');
        selectList.setAttribute('disabled', 'true');
        selectList.setAttribute('readonly','readonly');
        formGroup.appendChild(selectList);

        return formGroup;
    }

    printStructure(structure) {
        let that = this;
        let yearGroup = undefined;
        let ageGroup = undefined;
        // year and age should be handled in first call of the function not in it's recursion
        if(!this.printedJahrAlter) {
            // print jahr and alter separately
            // let year = structure.find(field => field.title === 'Jahr');
            let year = structure.find(field => {
                return (
                    field.title === 'Jahr' ||
                    field.title === 'Année' ||
                    field.title === 'Anno'
                );
            });

            if(year) {
                this.yearSelector = year.id;
                yearGroup = this.generateFormGroup(year);
                yearGroup.classList.add('used');
                let select = yearGroup.querySelector('select')
                select.removeAttribute('disabled');

            } else {
                console.log('yearGroup not found');
            }

            // let age = structure.find(field => field.title === 'Alter');
            let age = structure.find(field => {
                return (
                    field.title === 'Alter' ||
                    field.title === 'Âge' ||
                    field.title === 'Età'
                );
            });
            if(age) {
                ageGroup = this.generateFormGroup(age);
                ageGroup.classList.add('used');
                ageGroup.classList.add('current');
                ageGroup.querySelector('select').removeAttribute('disabled');
                this.innerForm.appendChild(ageGroup);
            } else {
                if(yearGroup) {
                    yearGroup.classList.add('current');
                }
            }

            if(yearGroup) {
                this.printedJahrAlter = true;
                this.innerForm.appendChild(yearGroup);
            }
            if(ageGroup) {
                this.printedJahrAlter = true;
                this.innerForm.appendChild(ageGroup);
            }
        }
        structure.forEach(function (field) {
            // if field label is Jahr or Alter, ignore input field
            if (
                !(((field.title === 'Jahr' || field.title === 'Année' || field.title === 'Anno') && field.parentId === null) || ((field.title === 'Alter' || field.title === 'Âge' || field.title === 'Età') && field.parentId === null))
            ) {
                let formGroup = that.generateFormGroup(field);
                let selectList = formGroup.querySelector('select');

                that.innerForm.appendChild(formGroup);

                // check if field has children
                if(typeof field.children && field.children.length > 0) {
                    that.printStructure(field.children);
                }
            } else {
                // year and age fields can also have children
                if(typeof field.children && field.children.length > 0) {
                    that.printStructure(field.children);
                }
            }
            that.formItemCount++;

        });
        return [yearGroup, ageGroup];
    }

    async getOptionsForCurrentSelect(currentFormItem) {
        currentFormItem = currentFormItem || this.innerForm.querySelector('fieldset.current');
        //get options for current select
        let currentSelect = currentFormItem.querySelector('select');
        let selectId = currentSelect.dataset.id;
        let options = await this.getOptions(selectId);
        //check if options are available
        if(options.length == undefined || options.length == 0 || (options.length == 1 && options[0].value == null)) {
            currentSelect.classList.add('skiped');
            currentSelect.closest('fieldset').classList.add('skiped');
            currentFormItem.classList.remove('used');
            currentFormItem.classList.remove('current');

            let nextFormItem = currentFormItem.nextSibling;
            if(nextFormItem !== null) {
                nextFormItem.classList.add('current');
                nextFormItem.classList.add('used');
                await this.getOptionsForCurrentSelect(nextFormItem);
            } else {
                this.submitButton.classList.remove('disabled');
            }
            return false;
        } else {
            currentSelect.removeAttribute('disabled');
        }
        let that = this;

        // Initialize select with tomselect
        this.initTomSelect(currentSelect, options);
        this.addEventListenersToCurrentFormItem(currentFormItem);
        // show form item
        currentFormItem.style.display = 'block';


        return true;
    }

    addEventListenersToCurrentFormItem(currentFormItem) {
        currentFormItem.addEventListener('change', (e) => {

            let criteriaStructureId = e.target.dataset.id;
            let criteriaListEntryId = e.target.value;
            let value = e.target.selectedOptions[0].text;
            if(criteriaListEntryId == value) {
                criteriaListEntryId = null;
            }

            // if currentFormItem has class current remove it else clear all following form items
            if(currentFormItem.classList.contains('current')) {
                currentFormItem.classList.remove('current');
            } else {
                // if changed Formitem is not current, clear all following form items
                currentFormItem.classList.add('current');
                let nextFormItemPointer = currentFormItem.nextSibling;
                while(nextFormItemPointer !== null) {
                    this.resetField(nextFormItemPointer);
                    nextFormItemPointer = nextFormItemPointer.nextSibling;
                }
            }

            // init next form item
            let nextFormItem = currentFormItem.nextSibling;
            if(nextFormItem !== null) {
                nextFormItem.classList.add('used');
                nextFormItem.classList.add('current');
                this.getOptionsForCurrentSelect(nextFormItem);
            } else {
                this.submitButton.classList.remove('disabled');
            }

        });
    }

    resetField(formItem) {
        let select = formItem.querySelector('select');
        let field = select.closest('fieldset');

        let tomselect = select.tomselect;
        if(tomselect) {
            tomselect.destroy();
        }
        select.tomselect = null;
        field.style.display = 'none';
        field.className = '';
        let s = select;
        let p = s.parentNode;
        let newSelect = s.cloneNode(false);
        p.removeChild(select);
        p.appendChild(newSelect);
    }

    async getOptions(criteriaId) {
        // fill this.selectedValues with values from used form items
        this.getUsedFormValues();

        let endpoint = `/api/minimumsalary/${this.editionId}/criteria/${criteriaId}?language=${this.language}-CH`;



        let url = this.apiUrl + endpoint;
        let requestHeaders = new Headers({
            "Unia-Api-Key": this.apiKey,
            'Content-Type': 'application/json'
        });
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: requestHeaders,
            body: JSON.stringify(this.selectedValues)
        });
        const options = await response.json();

        return options;
    }

    getFormValues(json) {
        let that = this;
        json.forEach(function (field) {
            let endpoint = `/api/minimumsalary/${that.editionId}/criteria/${field.id}?language=${this.language}-CH`;
            let url = that.apiUrl + endpoint;
            let requestHeaders = new Headers({
                "Unia-Api-Key": that.apiKey,
                'Content-Type': 'application/json'
            });
            fetch(url, {
                method: 'POST',
                mode: 'cors',
                headers: requestHeaders,
                body: JSON.stringify([{'CriteriaStructureId': 211716,'Value': '','CriteriaListEntryId': 0}])
            })
                .then(response => response.json())
                .then(json => {
                    if (json.success !== false) {
                        that.displayFormField(field, json);
                    } else {
                        console.warn('Query not successful:', json.message);
                    }
                }).catch((e) => {
                console.error('fetch error', e);
            });
        })
    }

    displayFormField(field, values) {
        //create and append label
        let label = document.createElement("label")
        label.htmlFor = `field-${field.id}`;
        label.innerText = field.title;
        this.innerForm.appendChild(label);

        //Create and append select list
        let select = document.createElement("select");
        select.id = `field-${field.id}`;
        select.setAttribute('autocomplete', 'off');
        select.setAttribute('readonly', 'readonly');
        select.dataset.id = field.id;
        select.dataset.parentid = field.parentId;

        this.innerForm.appendChild(selectList);

        this.initTomSelect(selectList, values);
    }

    initTomSelect(element, values, selectedValue) {
        selectedValue = selectedValue || null;
        if(element.dataset.id == this.yearSelector && selectedValue == null) {
            selectedValue = values[0].value;
        }
        selectedValue = selectedValue || null;
        let options = [];
        values.forEach((val) => {
            options.push({
                id: val.criteriaListEntryId || val.value,
                title: val.value
            });
        });
        let ts = null;
        if(!element.tomselect) {
            ts = new TomSelect(element, {
                allowEmptyOption: true,
                editable: false,
                searchable: false,
                searchField: ['title'],
                create: false,
                valueField: 'id',
                labelField: 'title',
                options: options,
                render:{
                    no_results:null,
                }
            });
        } else {
            ts = element.tomselect;
            ts.clearOptions();
            ts.addOption(options);
        }
        if (selectedValue) {
            let selectedOption = values.find(obj => obj.value === selectedValue);
            if (selectedOption.criteriaListEntryId != null) {
                selectedOption = selectedOption.criteriaListEntryId;
            } else {
                selectedOption = selectedOption.value;
            }

            ts.setValue(selectedOption);
        }
    }

    addSubmitListener() {
        let that = this;
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            that.addFormdata();
        });
    }

    getUsedFormLabels() {
        let labels = [];
        this.form.querySelectorAll('fieldset.used > label').forEach((label) => {
            let id = label.closest('fieldset').id.slice('9');
            let text = label.innerText;
            labels.push({id: id, text: text});
        });

        return labels;
    }

    getUsedFormValues() {
        this.selectedValues = [];
        this.form.querySelectorAll('fieldset.used, fieldset.skiped').forEach((field) => {
            let select = field.querySelector('select');
            let criteriaStructureId = select.dataset.id;
            let criteriaListEntryId = select.value;
            let selectedOption = select.options[select.selectedIndex];
            let value = null;
            if(selectedOption) {
                value = selectedOption.innerText;
                if(value != undefined && value == criteriaListEntryId) {
                    criteriaListEntryId = null;
                }
            }
            if(value != null) {
                this.selectedValues.push({
                    'CriteriaStructureId': criteriaStructureId,
                    'Value': value,
                    'CriteriaListEntryId': criteriaListEntryId
                });
            } else {
                this.selectedValues.push({
                    'CriteriaStructureId': criteriaStructureId,
                    'Value': null,
                    'CriteriaListEntryId': null
                });
            }
        });
    }

    addFormdata() {
        // refresh selectedValues
        this.getUsedFormValues();

        //save most recent data to local storage
        this.saveUserDataToLocalStorage();

        let formData = new FormData();
        formData.append('jobtitle', this.jobtitle);
        formData.append('zipcode', this.zipcode);
        formData.append('temporary', this.temporary);
        formData.append('contractNumber', this.contractNumber);
        formData.append('versionNumber', this.versionNumber);
        formData.append('editionId', this.editionId);
        formData.append('minsalaryLabels', JSON.stringify(this.getUsedFormLabels()));
        formData.append('minsalaryData', JSON.stringify(this.selectedValues));
        formData.append('contractName', this.contractName);
        formData.append('fileName', this.fileName);
        formData.append('fileId', this.fileId);

        formData.forEach((e, i) => {
            let input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", i);
            input.setAttribute("value", e);

            this.form.append(input);
        });


        this.form.submit();

    }

    saveUserDataToLocalStorage() {
        let userData = {
            jobtitle: this.jobtitle,
            zipcode: this.zipcode,
            temporary: this.temporary,
            contractNumber: this.contractNumber,
            versionNumber: this.versionNumber,
            editionId: this.editionId,
            contractName: this.contractName,
            fileName: this.fileName,
            fileId: this.fileId,
        };

        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('structure', JSON.stringify(this.formstructure));
        localStorage.setItem('selectedValues', JSON.stringify(this.selectedValues));
    }

}

